import { API_ENDPOINTS, useQuery } from "utilities";

const SelectedAddressQuery = () => {
  const storedAddressId = JSON.parse(localStorage.getItem("address"));
  const { data, isLoading, isError } = useQuery(
    `${API_ENDPOINTS.ADDRESS}/${storedAddressId}`,
    {
      enabled: !!storedAddressId, // Only fetch if storedAddressId exists
    }
  );

  return {
    data: data,
    isLoading,
    isError,
  };
};

export default SelectedAddressQuery;